/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ExternalReferral from './external-referral';
import ExternalReferralDetail from './external-referral-detail';
import ExternalReferralUpdate from './external-referral-update';
import ExternalReferralDeleteDialog from './external-referral-delete-dialog';

const ExternalReferralRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ExternalReferral />} />
    <Route path="new" element={<ExternalReferralUpdate />} />
    <Route path=":id">
      <Route index element={<ExternalReferralDetail />} />
      <Route path="edit" element={<ExternalReferralUpdate />} />
      <Route path="delete" element={<ExternalReferralDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ExternalReferralRoutes;
